module.exports = __webpack_public_path__ + "19_scivis.jpg?3252bf1105485c7aaf3aaad381c1ed43";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/19_scivis.jpg
// module id = 167
// module chunks = 0